/* @flow */
import { Set, Record, List, fromJS, Map } from 'immutable';
import { LOGICAL_TYPE } from './constants';

export type LogicalTypeType = $Keys<typeof LOGICAL_TYPE>;

export type RawSummaryAttributeType = {
  key: string,
  displayName: string,
  description: ?string,
  logicalType: ?LogicalTypeType,
  value: any,
}

export type RawSummaryType = {
  description: string,
  attributes: Array<RawSummaryAttributeType>,
  reportId: string,
};

export const Attribute = Record({
  key: '',
  displayName: '',
  value: '',
  logicalType: LOGICAL_TYPE.SCALAR,
  description: '',
});

export const Summary = Record({
  reportId: '',
  attributes: new List(),
  description: '',
  enclaveId: '',
  type: '',
  updated: 0,
  value: '',
  score: Map({name: '', value: ''}),
  source: Map({name: '', key: ''}),
  severityLevel: -1, // -1 Is Unknown
});

export type AttributeType = Record<Attribute>;
export type SummaryType = Record<Summary>;



// WEBPACK FOOTER //
// ./src/app/modules/summaries/types.js